import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import OrderForm from './components/OrderForm';
import Dashboard from './pages/Dashboard';
import AgentDashboard from './pages/AgentDashboard';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Tracking from './pages/Tracking';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import Help from './pages/Help';
import AdminDashboard from './pages/AdminDashboard';
import Support from './pages/Support';
import Refunds from './pages/Refunds';
import RefundManagement from './pages/RefundManagement';
import CouponManagement from './pages/CouponManagement';
import OrderTracking from './pages/OrderTracking';
import PaymentMethods from './pages/PaymentMethods';
import Delivery from './pages/Delivery';
import Categories from './pages/Categories';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import CheckoutLocal from './pages/CheckoutLocal';
import AdminProducts from './pages/AdminProducts';
import AdminAdvertisements from './pages/AdminAdvertisements';
import ProtectedRoute from './components/ProtectedRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <CartProvider>
          <Router>
          <div className="App">
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/order"
              element={
                <ProtectedRoute>
                  <OrderForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent"
              element={
                <RoleProtectedRoute allowedRoles={['agent', 'admin']}>
                  <AgentDashboard />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/payment/:orderId"
              element={
                <ProtectedRoute>
                  <Payment />
                </ProtectedRoute>
              }
            />
            <Route path="/orders/success" element={<PaymentSuccess />} />
            <Route path="/orders/cancel" element={<PaymentCancel />} />
            <Route
              path="/tracking/:orderId"
              element={
                <ProtectedRoute>
                  <Tracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <Notifications />
                </ProtectedRoute>
              }
            />
            <Route path="/help" element={<Help />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:productId" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <CheckoutLocal />
                </ProtectedRoute>
              }
            />
            <Route path="/order-tracking" element={<OrderTracking />} />
            <Route path="/payment-methods" element={<PaymentMethods />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route
              path="/admin"
              element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/support"
              element={
                <ProtectedRoute>
                  <Support />
                </ProtectedRoute>
              }
            />
            <Route
              path="/refunds"
              element={
                <ProtectedRoute>
                  <Refunds />
                </ProtectedRoute>
              }
            />
            <Route
              path="/refunds/manage"
              element={
                <RoleProtectedRoute allowedRoles={['agent', 'admin']}>
                  <RefundManagement />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/coupons"
              element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <CouponManagement />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/admin/products"
              element={
                <RoleProtectedRoute allowedRoles={['agent', 'admin']}>
                  <AdminProducts />
                </RoleProtectedRoute>
              }
            />
            <Route
              path="/admin/advertisements"
              element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminAdvertisements />
                </RoleProtectedRoute>
              }
            />
            </Routes>
          </div>
        </Router>
          </CartProvider>
      </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;

